import styled from 'styled-components';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { colors } from '../utils/colors'
import { fontFamily, purpleColors, violetColors, slateColors } from './ContentPages/AppLandingPage/styles';


// Styled wrapper for Calendar
const StyledCalendar = styled(Calendar)`
  /* Increase specificity so these overrides win against react-calendar's base CSS in prod */
  && {
    border: none;
    width: 100%;
    max-width: 100%;
  }
  font-family: ${fontFamily};

  .react-calendar__viewContainer {
    width: 100%;
  }

  .react-calendar__month-view {
    width: 100%;
  }

  .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    margin-bottom: 1.75rem;
    height: 100%;
  }

  .react-calendar__navigation button {
    margin: 0;
    padding: 0;
    border-radius: 50%;
    height: 2.5rem;
    width: 2.5rem;
    transition: all 0.2s;
  }

  .react-calendar__navigation button:disabled {
    background-color: transparent;
    opacity: 0.3;
  }

  .react-calendar__navigation__label {
    font-family: ${fontFamily};
    color: ${slateColors[900]};
    font-size: 1.125rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    transition: all 0.2s;
    
    &:hover {
      background: ${slateColors[50]};
    }
  }

  .react-calendar__navigation__prev2-button,
  .react-calendar__navigation__next2-button {
    display: none; /* Hide the year navigation buttons */
  }

  .react-calendar__navigation__prev-button,
  .react-calendar__navigation__next-button {
    display: flex;
    min-width: 2.5rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${slateColors[600]}; 
    border: 2px solid ${slateColors[200]};
    background: ${slateColors[50]};
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover:not(:disabled) {
      background: ${slateColors[100]};
      border-color: ${purpleColors[300]};
      color: ${slateColors[900]};
    }
    
    &:active:not(:disabled) {
      background: ${slateColors[200]};
      border-color: ${purpleColors[400]};
    }
  }

  .react-calendar__navigation__prev-button:disabled,
  .react-calendar__navigation__next-button:disabled {
    color: ${slateColors[300]};
    border-color: ${slateColors[200]};
    background: ${slateColors[50]};
    cursor: not-allowed;
  }

  .react-calendar__navigation__prev-button svg,
  .react-calendar__navigation__next-button svg {
    width: 1rem;
    height: 1rem;
  }

  .react-calendar__month-view__weekdays {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
  }

  .react-calendar__month-view__weekdays__weekday {
    font-family: ${fontFamily};
    font-size: 0.875rem;
    font-weight: 500;
    padding: 0;
    color: ${slateColors[600]};
    text-transform: lowercase;
    text-decoration: none;
    
    &::first-letter {
      text-transform: capitalize;
    }
    
    abbr {
      text-decoration: none;
      cursor: default;
    }
  }

  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    justify-items: center;
    row-gap: 0.5rem;
  }

  .react-calendar__tile {
    font-family: ${fontFamily};
    font-size: 1rem;
    font-weight: 500;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    color: ${slateColors[700]};
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    transition: all 0.2s;
    border: 2px solid transparent;
    background: transparent;
  }

  .react-calendar__tile:hover:not(.react-calendar__tile--disabled) {
    background: ${slateColors[100]};
    color: ${slateColors[900]};
    border-color: ${purpleColors[200]};
  }

  .react-calendar__tile--active {
    background: linear-gradient(to right, ${purpleColors[600]}, ${violetColors[600]});
    color: white;
    border-color: transparent;
    font-weight: 600;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1);
  }

  .react-calendar__tile--active:hover {
    background: linear-gradient(to right, ${purpleColors[700]}, ${violetColors[600]});
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  .react-calendar__tile--now {
    background: ${purpleColors[50]};
    border: 2px solid ${purpleColors[200]};
    color: ${purpleColors[700]};
    font-weight: 600;
  }

  .react-calendar__tile--now:hover:not(.react-calendar__tile--active) {
    background: ${purpleColors[100]};
    border-color: ${purpleColors[300]};
  }

  .react-calendar__tile--active.react-calendar__tile--now {
    background: linear-gradient(to right, ${purpleColors[600]}, ${violetColors[600]});
    color: white;
    border-color: transparent;
  }

  .react-calendar__tile--disabled {
    color: ${slateColors[300]};
    background: transparent;
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }
`;

export default StyledCalendar